
<div
    class="list"
    [attr.aria-hidden]="isListDataErrored"
>
    <ui-list
        [listItems]="listItems"
        [itemContentComponentType]="itemContentComponentType"
        [areFiltersExpanded]="areFiltersExpanded"
    >
        <div filters>
            <ng-content select="[filters]"/>
        </div>
    </ui-list>
</div>

@if (isListDataErrored) {
    <ui-full-page-overlay>
        <dialog
            pFocusTrap
            role="alertdialog"
            aria-live="assertive"
            aria-modal="true"
            aria-label="Fehlermeldung"
            tabindex=0
            class="error-message"
            [pAutoFocus]="true"
        >
            <i class="error-message__icon pi pi-times-circle color-error"></i>
            <span class="error-message__text">
                    Die Listendaten konnten nicht geladen werden.
            </span>
            <button pButton severity="primary"
                (click)="triggerListDataReload()"
                (keydown.enter)="triggerListDataReload()"
                (keydown.space)="triggerListDataReload()"
            >
                <span pButtonLabel>Neu laden</span>
            </button>
        </dialog>
    </ui-full-page-overlay>
}
